import {useMutation} from "@tanstack/react-query";

import {deleteSupplierFunctionMutationOptions} from "./delete-supplier-function.mutation-options";

export function useDeleteSupplierFunction() {
  return useMutation(deleteSupplierFunctionMutationOptions());
}
